__turbopack_context__.v({
  "className": "noto_sans_tamil_d843b79a-module__tvB_YG__className",
});
